import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #IMAGE-GALLERY-THUMBNAIL-ITEM
\*------------------------------------ */
/**
 * 1) Image gallery-thumbnail item
 */
.cat-c-image-gallery-thumbnail-item {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: calc(var(--size-base-unit) * 10);
  height: calc(var(--size-base-unit) * 10);
}
.cat-c-image-gallery-thumbnail-item.cat-c-image-gallery-thumbnail-item--small {
  width: auto;
  height: auto;
}

/**
   * Link on image gallery-thumbnail item
   */
.cat-c-image-gallery-thumbnail-item__link {
  outline: none;
  cursor: pointer;
  display: flex;
  border-radius: var(--cat-border-radius-lg);
  border: 1px solid var(--cat-theme-color-border-default);
}
.cat-c-image-gallery-thumbnail-item__link:hover {
  border: 1px solid var(--border-default-hover, var(--cat-theme-color-border-default-hover));
}
.cat-c-image-gallery-thumbnail-item__link:active, .cat-is-active .cat-c-image-gallery-thumbnail-item__link {
  outline: 2px solid var(--cat-theme-color-border-brand);
  outline-offset: -2px;
}
.cat-c-image-gallery-thumbnail-item--small .cat-c-image-gallery-thumbnail-item__link {
  border: none;
  outline: none;
}

/**
   * Slotted image
   */
::slotted(img),
.cat-c-image-gallery-thumbnail-item__image {
  border-radius: calc(var(--size-base-unit) * 0.875);
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cat-c-image-gallery-thumbnail-item__dot {
  width: calc(var(--size-base-unit) * 6);
  height: calc(var(--size-base-unit) * 6);
  border-radius: var(--cat-theme-border-radius);
  position: relative;
  margin: calc(var(--size-base-unit) * 2);
}
.cat-c-image-gallery-thumbnail-item__dot:after {
  content: "";
  position: absolute;
  width: calc(var(--size-base-unit) * 2);
  height: calc(var(--size-base-unit) * 2);
  border-radius: 100%;
  background-color: var(--cat-theme-color-background-strong);
  inset-block-start: calc(var(--size-base-unit) * 2);
  inset-inline-start: calc(var(--size-base-unit) * 2);
}
.cat-is-active .cat-c-image-gallery-thumbnail-item__dot:after {
  background-color: var(--cat-theme-color-background-xstrong);
}
.cat-c-image-gallery-thumbnail-item__dot:hover:after {
  background-color: var(--cat-theme-color-background-xstrong);
}

.cat-c-image-gallery-thumbnail-item:not(.cat-c-image-gallery-thumbnail-item--has-default) [part=thumbnail-item-link-slot] {
  display: none;
}
`;
       